import { CircularProgress, Icon } from '@mui/material';

export function CircularProgressIcon(props) {
    return (
        <Icon {...props}>
            <CircularProgress style={{ display: 'inherit', width: '100%', height: '100%' }} color="inherit" />
        </Icon>
    );
}
